module.exports = __webpack_public_path__ + "media/profile_pictures/profile-picture-6-5db99015.jpg";